import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Hero = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <div id="home" className="section" style={{ padding: "0" }}>
      <div className="desktopview">
        <img
          onClick={() => handleShowModal("Web Banner")}
          height="100%"
          width="100%"
          className="d-block micro-main-slider-img ls-is-cached lazyloaded"
          src="images/living.jpg"
          alt="banner"
        />
      </div>
      <div className="mobileview">
        <img
          onClick={() => handleShowModal("Mob Banner")}
          height="100%"
          width="100%"
          className="d-block micro-main-slider-img ls-is-cached lazyloaded"
          src="images/living.jpg"
          alt="banner"
        />
      </div>
    </div>
  );
};

export default Hero;
